import { Translation } from "@/data/lang";

import { TabProps } from "ui/core/horizontal-tab";

export const getMarginTransactionsTabOptions = ({
  t,
}: {
  t: Translation;
}): TabProps[] => [
  {
    key: "marginDiff",
    name: t.analysis.chip.marginTransactions.margin,
    label: t.analysis.chip.marginTransactions.margin,
  },
  {
    key: "shortDiff",
    name: t.analysis.chip.marginTransactions.short,
    label: t.analysis.chip.marginTransactions.short,
  },
  {
    key: "marginShortRatio",
    name: t.analysis.chip.marginTransactions.marginShortRatio,
    label: t.analysis.chip.marginTransactions.marginShortRatio,
  },
  {
    key: "marginUtilization",
    name: t.analysis.chip.marginTransactions.marginUtilization,
    label: t.analysis.chip.marginTransactions.marginUtilization,
  },
];
